module.exports = __webpack_public_path__ + "img/emoji-fail.907adb93.png";